import { defineComponent as _defineComponent } from 'vue'
import Vuex from "@/store/index";
import { Authority } from "@/models/enum/Enum";
import ApprovalHome from "@/components/home/ApprovalHome.vue";
import CheckHome from "@/components/home/CheckHome.vue";
import LeaderHome from "@/components/home/LeaderHome.vue";
import AccountantHome from "@/components/home/AccountantHome.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'MainHome',
  setup(__props) {

const authority = Vuex.state.authority;

return { __sfc: true,authority, Authority, ApprovalHome, CheckHome, LeaderHome, AccountantHome }
}

})